import { Project, ProjectMember } from './types';

export const defaultProjects: Project[] = [];

export const previewAssignableUsers: Array<Omit<ProjectMember, 'role'>> = [
  { id: 'preview-ada', name: 'Ada Lovelace', email: 'ada@example.com' },
  { id: 'preview-grace', name: 'Grace Hopper', email: 'grace@example.com' },
  { id: 'preview-alan', name: 'Alan Turing', email: 'alan@example.com' },
];
